import Emitter from "es6-event-emitter";
import { injectScript } from "./../utilities/DOMUtils";

export default class LmoCMP extends Emitter {
  constructor() {
    super();
    injectScript(
      "https://cmp.lemonde.fr/js/tcfv2-stub.min.js",
      this._onTfcv2load.bind(this),
      false,
      null,
      false
    );
    injectScript(
      "https://cmp.lemonde.fr/js/lemonde.min.js",
      this._onSDKload.bind(this),
      false,
      null,
      true
    );

    document.addEventListener("gdprConsentGiven", () => {
      this.trigger("userConsent:changed");
    });
  }

  _onTfcv2load() {
    window.GDPR_CONFIG = {
      displayMode: "standard",
    };
  }

  _onSDKload() {
    this.trigger("cmp:loaded");
  }

  getPurposes() {
    if (window.gdpr && typeof window.gdpr.getPurposes === "function") {
      return window.gdpr.getPurposes();
    }
    return null;
  }

  getConsent() {
    if (window.gdpr && typeof window.gdpr.hasConsent === "function") {
      return window.gdpr.hasConsent();
    }
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/common/cmp/lmo-cmp.js